<template>
  <div class="container mt-5 has-text-centered" style="min-height: 300px;">
    <div class="hero">

      <p class="subtitle is-4 mt-5">Completing authorization...</p>
      <div class="control mt-5 is-loading"></div>

    </div>
  </div>
</template>
<script>

import auth from '../api/auth'

export default {
  name: "AuthCallback",

  mounted() {
    let params = {
      oauth_token: this.$route.query.oauth_token,
      oauth_verifier: this.$route.query.oauth_verifier,
    }

    // make sure the returned token is what we saved before redirect
    if (this.$route.query.oauth_token === this.$ls.get('pre-auth-token')) {
      this.$ls.remove('pre-auth-token')
      auth.apiCall('auth/twitter/verify', params).then(response => {
        this.$ls.set('new-auth-token', response.data)
        window.close()
      })
    } else {
      window.close()
    }

  }
}
</script>

<style lang="scss" scoped>
.control.is-loading {
  position: static;

  &:after {
    position: absolute;
    left: calc(50% - 1rem);
    width: 4rem;
    height: 4rem;
  }
}
</style>
